// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Configuration/Operator';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveOperatorConfiguration: () => UseMutationResult<
  void,
  string,
  {
    operatorConfigurationCid: ContractId<OperatorConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveOperatorConfiguration', ledgerApi],
    mutationFn: async ({ operatorConfigurationCid }) => {
      return ledgerApi.archiveRegistryOperatorConfiguration(operatorConfigurationCid);
    },
    retry: false,
  });
};

export default useArchiveOperatorConfiguration;
